import { CustomerDetailPage } from "@/features/customer/pages/CustomerDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/customer/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["customer.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: CustomerDetailPage,
});
